import { useEffect, useState } from "react";
import { modelSupplyPath } from "./api";
import { accountAmount, platformCatalog } from "./modelSupply";

/** How often the sidebar asks again what the account has left, while the page is in front. */
const EVERY = 60_000;

/**
 * What the signed-in account can still spend, written ("¥27.86"), for the account row in the sidebar.
 * It is what the Hub answers about the account's model allowance; an answer that is missing or not
 * whole shows nothing (never a zero that was not said), and a later failed read keeps the last good one.
 */
export function useAccountCredit(accountId: string): string | undefined {
  const [credit, setCredit] = useState<string>();
  useEffect(() => {
    const controller = new AbortController();
    let timer = 0;
    const read = async () => {
      try {
        const response = await fetch(modelSupplyPath, { signal: controller.signal, credentials: "same-origin", headers: { Accept: "application/json" } });
        if (!response?.ok) return;
        const offer = platformCatalog(await response.json());
        if (offer && !controller.signal.aborted) setCredit(accountAmount(offer.usage.remaining_cny));
      } catch { /* The row simply says nothing about money. */ }
    };
    const later = () => {
      timer = window.setTimeout(() => { if (document.visibilityState === "visible") void read(); later(); }, EVERY);
    };
    const visible = () => { if (document.visibilityState === "visible") void read(); };
    void read();
    later();
    document.addEventListener("visibilitychange", visible);
    return () => { controller.abort(); window.clearTimeout(timer); document.removeEventListener("visibilitychange", visible); };
  }, [accountId]);
  return credit;
}
